import { AxiosClient } from "redux/AxiosClient";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAllFeedbackAsync = createAsyncThunk(
  "admin/getAllFeedback",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/getAllFeedback?page=${payload.page || ""}&limit=${
        payload.limit || ""
      }&search=${payload.search || ""}`,
      [],
      toolkit
    );
  }
);

export const createFeedbackAsync = createAsyncThunk(
  "admin/createFeedback",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/createFeedback`, payload, toolkit);
  }
);
export const getFeedbackByIdAsync = createAsyncThunk(
  "admin/getFeedbackById",
  async (payload, toolkit) => {
    return await AxiosClient("GET", `/getFeedbackById/${payload}`, [], toolkit);
  }
);
export const updateTestFeedbackDataAsync = createAsyncThunk(
  "admin/updateFeedback",
  async (payload, toolkit) => {
    return await AxiosClient("PUT", `/updateFeedback`, payload, toolkit);
  }
);
